import { Avatar } from '@dixa/lib-shared-habla';
import { User } from 'lib-shared-types-api';

import { AppLink } from 'components/appLink';
import { getUserDisplayName } from 'utils/user/getUserDisplayName';

import styles from './conversationHeaderPastAssignee.module.scss';

export type ConversationPastAssigneeProps = {
  agent: User;
};

export const ConversationHeaderPastAssignee = ({
  agent,
}: ConversationPastAssigneeProps): JSX.Element => {
  return (
    <AppLink
      path="/contacts/user/:id"
      params={{
        path: { id: agent.id },
      }}
    >
      <div className={styles.root}>
        <Avatar user={agent} />

        <div>
          <div className={styles.name}>{getUserDisplayName(agent)}</div>
        </div>
      </div>
    </AppLink>
  );
};
